import React from 'react';
import PropTypes from 'prop-types';

import IconSvg from 'components/Core/IconSvg';
import trackAction from 'utils/tracking';

import {
  ActivityThemeWrap,
  ActivityThemeTitle,
  ActivityThemeSubtitle,
  ActivityThemeItemsWrap,
  ActivityThemeItem,
  ActivityThemeIconWrap,
  ActivityThemeContent,
  ActivityThemeAnchor,
} from './ActivityTheme.styles';

const renderTitle = (title, accommodationName) => {
  const titleParts = title.split('{ accommodation_name }');
  return titleParts.length > 1 ? (
    <ActivityThemeTitle>
      {titleParts[0]}
      <span className="text-secondary">{accommodationName}</span>
      {titleParts[1]}
    </ActivityThemeTitle>
  ) : (
    <ActivityThemeTitle>{titleParts[0]}</ActivityThemeTitle>
  );
};

const ActivityTheme = (props) => {
  const { siteName: accommodationName, title, subtitle, themes, onClickTheme, showWizardSetting } = props;

  const trackActivityThemeClick = (label) => trackAction('activity-tracker', label, 'click');

  return (
    <div className="container mx-auto px-4">
      <ActivityThemeWrap data-test-id="component-activity-theme-chooser">
        {renderTitle(title, accommodationName)}
        {subtitle && <ActivityThemeSubtitle>{subtitle}</ActivityThemeSubtitle>}
        {showWizardSetting && (
          <ActivityThemeItemsWrap data-test-id="themes">
            {themes.map((theme) => (
              <ActivityThemeItem
                onClick={() => {
                  trackActivityThemeClick(theme.name);
                  onClickTheme(theme);
                }}
                onKeyPress={() => {
                  trackActivityThemeClick(theme.name);
                  onClickTheme(theme);
                }}
                key={`activityTheme-${theme.id}`}
              >
                <ActivityThemeIconWrap icon={theme.icon}>
                  <IconSvg icon={theme.icon} size={50} />
                </ActivityThemeIconWrap>

                <ActivityThemeContent>
                  <ActivityThemeAnchor>
                    <span className="mr-1">{theme.name}</span>
                    <IconSvg
                      icon="arrow-right"
                      size={10}
                      className="transition-spacing duration-150 min-w-20px group-hover:pl-2"
                    />
                  </ActivityThemeAnchor>
                  <span className="inline-block lg:pt-2 w-full">{theme.shortDescription}</span>
                </ActivityThemeContent>
              </ActivityThemeItem>
            ))}
          </ActivityThemeItemsWrap>
        )}
      </ActivityThemeWrap>
    </div>
  );
};

ActivityTheme.defaultProps = {
  siteName: 'Sportfondsen',
  title: 'Wat wil je doen bij { accommodation_name }?',
  subtitle: null,
  themes: [],
  overviewPage: {
    url: null,
  },
  onClickTheme: () => {},
  showWizardSetting: true,
};

ActivityTheme.propTypes = {
  siteName: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onClickTheme: PropTypes.func,

  themes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      shortDescription: PropTypes.string,
      id: PropTypes.string,
      icon: PropTypes.string,
    }),
  ),
  overviewPage: PropTypes.shape({
    url: PropTypes.string,
  }),
  showWizardSetting: PropTypes.bool,
};

export default ActivityTheme;
